import React from "react";
import { Modal } from "react-bootstrap";
import { ModalTemplate } from "../modalTemplate";

import { LoaderOverlay } from "../../../component";
import { LoaderOverlayNewsLetter } from "../../../component/Loader";

const ModalComponent = function({
  template = <ModalTemplate />,
  size = "lg",
  onClose = () => {},
  classes = "",
  isLoading = false,
  containerClass,
  ModalDialog,
  backdropClassName = "",
  centered,
  loadingPercent = 0,
  backdrop = "",
  dataTest = "modal",
  hideProgressbar,
  newsLetter,
  loadingNewsLetter,
  uploadStatus
}) {
  return (
    <Modal
      show={true}
      size={size}
      dialogAs={ModalDialog}
      onHide={onClose}
      backdrop={backdrop}
      dialogClassName={containerClass}
      centered={centered}
      backdropClassName={backdropClassName}
      className={`modal-common-template ${classes}`}
      data-test={dataTest}
    >
      {template}
      {hideProgressbar ? null : newsLetter ? (
        <LoaderOverlayNewsLetter
          loading={loadingNewsLetter}
          loadingPercent={uploadStatus}
          newsLetter={true}
        />
      ) : (
        <LoaderOverlay loading={isLoading} loadingPercent={loadingPercent} />
      )}
    </Modal>
  );
};

export { ModalComponent };
